(function($) {
    $.widget("ca.caMembershipSelect", {
        _create : function() {
            $('.ca-membership-select').find('.nav').on('click', function() {
                $(this).parents('.ca-membership-select').find('input[type=checkbox]').prop('disabled', false);
            });
        }
    });
})(jQuery);
